export class PocsagItem {
    constructor (public id: string,
                 public uid: string,
                 public zeit: string[],
                 public bezeichnung: string[],
                 public farbe: string[],
                 public nachricht: string,
                 public icon: string) {
    }
}
